import shiptypeallComponent from './shiptype.all.component';

let shiptypeallModule = angular.module('shiptypeall', [
])

.component('shiptypeall', shiptypeallComponent)

.name;

export default shiptypeallModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/all/index.js